import React, { useEffect, useState } from 'react';
import { Box, Button, Divider, Grid, Typography } from '@mui/material';
import { User } from 'src/interfaces/iuser';
import BillingTab from './BillingTab';
import ProfileTab from './ProfileTab';
import ComingSoon from './ComingSoon';
import ProductSettingsTab from './ProductSettingsTab';
import { COLOR_PRIMARY_2 } from 'src/utils/colors';
import { COLOR_PRIMARY } from 'src/utils/const';
import { getUserPreferredCurrency } from 'src/utils/functions';
import OrganizationSettingsTab from './OrganizationSettingsTab';

type TabTypes = 'profile' | 'billing' | 'organization_settings' | 'product_settings';

const SettingsDashboardV2 = ({
  user,
  isMobileView,
  setShowUpgradeYearlySubscriptionModal,
  currency,
  setCurrency,
  OverviewLandingPageComponent,
  EstimatorDashboardComponent,
  isLoggedIn,
  setLoginModalOpen,
  isMobileScreen,
  resetCurrencyToDefault,
}: {
  user: User;
  isMobileView: boolean;
  setShowUpgradeYearlySubscriptionModal;
  currency: string;
  setCurrency: any;
  OverviewLandingPageComponent: JSX.Element;
  EstimatorDashboardComponent: JSX.Element;
  isLoggedIn: boolean;
  setLoginModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isMobileScreen: boolean;
  resetCurrencyToDefault: () => void;
}) => {
  const [selectedTab, setSelectedTab] = useState<TabTypes>('profile');

  useEffect(() => {
    resetCurrencyToDefault();
  }, []);

  const settingPageTabMap = [
    {
      key: 'profile',
      tab: 'Profile',
      action: () => setSelectedTab('profile'),
    },
    {
      key: 'billing',
      tab: 'Billing',
      action: () => setSelectedTab('billing'),
    },
    {
      key: 'organization_settings',
      tab: 'Organization Settings',
      action: () => setSelectedTab('organization_settings'),
    },
    {
      key: 'product_settings',
      tab: 'Product Settings',
      action: () => setSelectedTab('product_settings'),
    },
  ];

  const generateSettingTabs = () => {
    return (
      <Grid container spacing={2}>
        {settingPageTabMap.map((settingsItem, index) => (
          <Grid item>
            <Button
              variant={settingsItem.key === selectedTab ? 'contained' : 'outlined'}
              onClick={settingsItem.action}
              sx={{
                ...(settingsItem.key === selectedTab
                  ? { color: '#fff', background: COLOR_PRIMARY_2 }
                  : { borderColor: COLOR_PRIMARY_2, color: COLOR_PRIMARY_2 }),
              }}
            >
              {settingsItem.tab}
            </Button>
          </Grid>
        ))}
      </Grid>
    );
  };

  if (!isLoggedIn) {
    return (
      <Grid
        container
        flexDirection={'column'}
        sx={{
          minHeight: '100dvh',
          padding: '20px',
          background: '#fff',
        }}
      >
        <Typography variant="body1" sx={{ mt: '20px' }}>
          You are currently logged out.{' '}
          <span
            onClick={() => setLoginModalOpen(true)}
            style={{
              color: COLOR_PRIMARY,
              textDecoration: 'underline',
              cursor: 'pointer',
            }}
          >
            Sign Up.
          </span>
        </Typography>
      </Grid>
    );
  }

  return (
    <>
      <Grid
        container
        flexDirection={'column'}
        sx={{
          minHeight: '100dvh',
          padding: '20px',
          background: '#fff',
          pb: '100px',
        }}
      >
        <Grid item xs={12} sx={{ mt: '30px' }}>
          <Typography variant="h4">Settings</Typography>
        </Grid>
        <Grid item xs={12} sx={{ mt: '20px' }}>
          {generateSettingTabs()}
          <Divider sx={{ my: '10px' }} />
        </Grid>
        <Grid item container xs={12}>
          {selectedTab === 'profile' && <ProfileTab user={user} />}
          {selectedTab === 'billing' && (
            <BillingTab
              isMobileView={isMobileView}
              setShowUpgradeYearlySubscriptionModal={setShowUpgradeYearlySubscriptionModal}
            />
          )}
          {selectedTab === 'organization_settings' && <OrganizationSettingsTab user={user} />}
          {selectedTab === 'product_settings' && (
            <ProductSettingsTab
              user={user}
              currency={currency}
              setCurrency={setCurrency}
              OverviewLandingPageComponent={OverviewLandingPageComponent}
              EstimatorDashboardComponent={EstimatorDashboardComponent}
              isMobileScreen={isMobileScreen}
            />
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default SettingsDashboardV2;
